import { analyticsTrackEvent } from '@core/utils/analytics';
import {
  HOME_PAGE_ITEM_TYPE,
  HOME_PAGE_VIEWED,
  HOME_VIEW_ALL_CLICKED,
  HOME_WIDGET_ITEM_TYPE,
  HOME_WIDGET_LOADED,
} from '@core/constants/analytics';

export const trackHomeViewAllClicked = (
  navigationSource: string,
  count: number
) => {
  analyticsTrackEvent(HOME_VIEW_ALL_CLICKED, {
    itemType: HOME_WIDGET_ITEM_TYPE,
    navigationSource,
    count,
  });
};

export const trackHomePageViewed = (navigationSource: string) => {
  analyticsTrackEvent(HOME_PAGE_VIEWED, {
    itemType: HOME_PAGE_ITEM_TYPE,
    navigationSource,
  });
};

export const trackHomeWidgetLoaded = (
  navigationSource: string,
  count: number
) => {
  analyticsTrackEvent(HOME_WIDGET_LOADED, {
    itemType: HOME_WIDGET_ITEM_TYPE,
    navigationSource,
    count,
  });
};
